"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const react_1 = __importDefault(require("react"));
const Button_elements_1 = require("./Button.elements");
const Button_configs_1 = require("./Button.configs");
const Button = ({ type, variant, children, onClick, disabled, }) => {
    return (react_1.default.createElement(Button_elements_1.StyledButton, { type: type, disabled: disabled, onClick: onClick, style: Button_configs_1.buttonStyles[variant] }, children));
};
exports.Button = Button;
